export const GET_ALL_NOTIFICATION = "GET_ALL_NOTIFICATION";
export const GET_ALL_NOTIFICATION_SUCCESS = "GET_ALL_NOTIFICATION_SUCCESS";
export const GET_ALL_NOTIFICATION_FAILED = "GET_ALL_NOTIFICATION_FAILED";
export const NOTIFICATION_STATUS_UPDATE = "NOTIFICATION_STATUS_UPDATE";
export const NOTIFICATION_DELETE = "NOTIFICATION_DELETE";
export const NOTIFICATION_STATUS_ARCHIVE_UPDATE = "NOTIFICATION_STATUS_ARCHIVE_UPDATE";
export const NOTIFICATION_STATUS_UN_ARCHIVE_UPDATE = "NOTIFICATION_STATUS_UN_ARCHIVE_UPDATE";
export const GET_ALL_NEW_NOTIFICATION_SUCCESS = "GET_ALL_NEW_NOTIFICATION_SUCCESS";
export const GET_ARCHIVE_NOTIFICATION_SUCCESS = "GET_ARCHIVE_NOTIFICATION_SUCCESS";